import React, { useState, useEffect } from 'react';
import './OfflineBanner.css';

/**
 * Persistent banner shown when the device is offline.
 * Uses navigator.onLine + online/offline events.
 */
const OfflineBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(() =>
    typeof navigator !== 'undefined' ? !navigator.onLine : false
  );

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="offline-banner" role="alert">
      <span className="offline-banner-icon">📡</span>
      <span>You&apos;re offline — Showing your last saved trips</span>
    </div>
  );
};

export default OfflineBanner;
